import React, { useEffect, useState } from 'react';
import ModalFormState from '../../components/forms/config/modal.form.states'
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

function ListStates() {
  const [msgGet ,setMsgGet] = useState('');
  const [states,setStates] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  useEffect(() => {
    getStates()

  }, []);

  const createStates = (variant, msg) => {
    setAlert({ show: true, message: msg, type: variant });
    getStates()
  };

  const editButton = (row) => {
    return (
      <ModalFormState
        title="Modificar Estado"
        button_text="Editar"
        button_variant="outline-primary"
        stateSelect={row.id}
        callback={createStates}
      ></ModalFormState>
    );
  };

  const getStates = async()=>{
    const responseStates = await get('/config/states/',{})
    if(responseStates.success){
      setStates(responseStates.data);
    }else{
      setMsgGet(responseStates.message)
    }       
  }

  return (
    <Base>
      {/* <TempAlert show={alert.show} variant="success" message={alert.message} hide={setAlert} ></TempAlert> */}
      {alert.show && <Alert variant="success" onClose={() => setAlert({show: false})} dismissible>{alert.message}</Alert>}
      <ModalFormState
        title="Crear Estado"
        button_text="Crear Estado"
        button_variant="primary"
        callback={createStates}
      ></ModalFormState>
      <ListTables
        data={states}
        editar={editButton}
        messageWd={msgGet}
      />
    </Base>
  );
}

export default ListStates;
